export const parseInteger = (value: string): number => {
  const parsed = parseInt(value.trim());
  return isNaN(parsed) ? 0 : parsed;
};

export const parseDecimal = (
  value: string | number,
  maxDecimals: number,
): number => {
  const num = typeof value === "string" ? parseFloat(value.trim()) : value;
  if (isNaN(num) || num === null || num === undefined) return 0;
  return parseFloat(num.toFixed(maxDecimals));
};

export const isValidDecimalInput = (
  val: string,
  decimals: number,
  allowNegative = true,
): boolean => {
  if (val === "") return true;
  const pattern = allowNegative
    ? new RegExp(`^\\s*-?\\d*\\.?\\d{0,${decimals}}\\s*$`)
    : new RegExp(`^\\s*\\d*\\.?\\d{0,${decimals}}\\s*$`);
  return pattern.test(val);
};
